import { environment } from 'environments/environment';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '@services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AuctionService } from '@services/auction/auction.service';
import { ReportService } from '@services/report/report.service';
import moment from 'moment';

import { Subscription } from 'rxjs';
import { LoadingService } from '@services/loading/loading.service';
import { WebSocketService } from '@services/websocket/websocket.service';
import { SharedService } from '@services/shared/shared.service';
import { auctionUser } from '@/helpers/constant';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-auction-carinfo',
  templateUrl: './auction-carinfo.component.html',
  styleUrls: ['./auction-carinfo.component.scss'],
})
export class AuctionCarinfoComponent implements OnInit {
  public updateFormToggle: boolean = false;
  public updatePassForm: FormGroup = null;
  public viewUserDetails: any;
  public updateBiddingForm: FormGroup = null;
  public isBiddingPrice: boolean = true;
  public purchaseBiddingPointArr: any[] = [];
  public getUserId: any;
  public productData: any;
  public allData: any;
  public live_auction_start_date_time: any;
  public highestBid: any;
  public min_price: any;
  public reserve_price: any;
  public auction_type: any;
  public daysRemaining: any;
  public slides: any;
  public productInfo: any;
  public showIndiviDualCrad: any;
  public getTitle: any;
  public getImageUrl: string = '';
  public bidHistoryData: any[] = [];
  public liveBidValue: any;
  public loading: boolean = false;
  public activroute: any;
  public approveRequire: boolean;
  public approveStatus: boolean;
  public queryParam: string;
  public paymentDocAvailable: string = '';
  public paymentDocApproved: boolean = false;
  public paymentDocRejected: boolean = false;
  public paymentPending: boolean;
  public paymentDocStaus: boolean;
  public isBulkAuction: boolean = false;
  public isBatchAuction: boolean = false;
  public isIndividualAuction: boolean = false;
  public currentAuction: object = {};
  public vehicles: object[] = [];
  public vehicleDetails: object = {};
  public showVehicleDetails: boolean = false;
  public env: string = environment.forntend_url;
  public invoice: object[] = [];
  public laddaLoading: boolean = false;
  public invoiceAvailable: boolean = false;
  public invoiceUrl: string = '';
  public invoiceId: string = '';
  public uploadBtnStatus: boolean = true;
  public getVehicleId: string = '';
  public docStatus: object = {};
  public paymentDocId: string = '';
  public paymentDoc: object[] = [];
  public laddaApproveBtn: boolean = false;
  public laddaBtns: boolean[] = [];
  public whyReject: string = '';
  public rejectLaddaBtn: boolean = false;
  public modalRef?: BsModalRef;
  public modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-lg',
  };
  public paymentDocIndex: number;
  public globalDocsObj = {
    'Payment Receipts': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    Invoice: {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Sales Order': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Approved Delivery Note': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    'Untransferred ISTIMARA ( Registration card )': {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
    Other: {
      available: false,
      imageUrl: '',
      enableUpload: false,
      id: '',
      uploadTime: '',
    },
  };

  // public customersDocs = {
  //   Payment: {},
  //   Invoice: {}
  // }
  public availableMVPI: boolean = false;
  public availableInsurance: boolean = false;
  public rejectDocName: string = '';

  constructor(
    public formBuilder: FormBuilder,
    public userService: UserService,
    public toastr: ToastrService,
    public router: Router,
    public auctionService: AuctionService,
    public reportService: ReportService,
    public webSocket: WebSocketService,
    public loader: LoadingService,
    public activatedRoute: ActivatedRoute,
    public sharedService: SharedService,
    private modalService: BsModalService
  ) {
    this.activroute = activatedRoute.snapshot.paramMap.get('auctionId');
    this.getImageUrl = `${environment.forntend_url}assets/img/car-placeholder.png`;
  }

  public receiveBidsChangeSubscription: Subscription = new Subscription();
  public auctionClosed: boolean = false;
  ngOnInit(): void {
    this.getAuctionProductDetails();
    this.bidHistory();
    // this.webSocket.openWebSocket(this.activroute);
    this.receiveBidsChangeSubscription =
      this.webSocket.receiveBidsChange.subscribe((item) => {
        if (item) {
          this.liveBidValue = item[0];
          let date = moment(new Date()).format('DD-MM-YYYY');
          let time = moment(new Date()).format('hh:mm:ss A');

          if (
            this.bidHistoryData[this.bidHistoryData.length - 1]
              ?.Bidding_amount !== this.liveBidValue
          ) {
            let currentBid = {
              Bidding_amount: this.liveBidValue.bid,
              Bidding_time: time,
              Bidding_date: date,
              ...this.liveBidValue,
            };
            if (currentBid['auctionStatus']) {
              this.auctionClosed = true;
            }

            this.bidHistoryData = [currentBid, ...this.bidHistoryData];
            this.toastr.info(
              currentBid.bidAmount,
              `${currentBid?.['first_name']} ${currentBid?.['last_name'] || ''}`
            );
          }
        }
      });

    this.getPaymentDoc();
    // this.getAuctionInvoice(this.activroute)
  }

  ngOnDestroy() {
    this.webSocket.closeWebSocket();
    this.receiveBidsChangeSubscription.unsubscribe();
  }

  getPaymentDoc() {
    this.reportService
      .viewPaymentDoc(this.activroute)
      .subscribe((res: { data: object; message: string; success: boolean }) => {
        if (res.success === true) {
          this.paymentPending = res.data?.['status'] === null ? true : false;
          // this.paymentDocStaus = res.data['status']
          this.paymentDocId = res.data?.['userDoc']?.[0]?.['doc_id'];
          this.paymentDoc = res.data?.['userDoc'];
          this.paymentDocAvailable =
            res.data?.['userDoc']?.[0]?.['imageUrl']?.['presigned_url'];
          if (this.paymentDoc && this.paymentDoc.length) {
            this.paymentDoc.forEach((data) => {
              if (
                data['document_name'] === 'MVPI' &&
                data['payment_doc_status'] === true
              ) {
                this.availableMVPI = true;
              }
              if (
                data['document_name'] === 'Insurance' &&
                data['payment_doc_status'] === true
              ) {
                this.availableInsurance = true;
              }
              if (
                data['document_name'] === 'Payment' &&
                data['payment_doc_status'] === true
              )
                this.paymentDocStaus = true;
            });
          }

          if (this.availableInsurance && this.availableMVPI) {
            this.globalDocsObj['Transferred ISTIMARA ( Registration card )'] = {
              available: false,
              imageUrl: '',
              enableUpload: false,
              id: '',
              uploadTime: '',
            };
          }

          this.getAuctionInvoice(this.activroute);
        }
      });
  }

  viewPaymentDoc(url: string) {
    window.open(url, '_blank');
  }

  updatePaymentDocStatus(
    status: number,
    index: number,
    docId: string,
    docName: string
  ) {
    this.loading = true;
    this.paymentDocId = docId;
    this.docStatus = { approve: status, document_id: this.paymentDocId };
    this.paymentDocIndex = index;
    let auctionToken = JSON.parse(localStorage.getItem('auctionUser'));

    if (docName === 'Payment') {
      if (auctionToken) {
        this.checkVehicleStatus();
      } else {
        this.auctionAuthCheck();
      }
    } else {
      this.updateDocStatus();
    }
  }

  auctionAuthCheck() {
    this.auctionService.auctionAuthenticationCheck(auctionUser).subscribe(
      (res) => {
        if (res['success']) {
          localStorage.setItem('auctionUser', JSON.stringify(res));
          this.checkVehicleStatus();
        }

        this.loading = false;
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Something went wrong!');
        this.loading = false;
      }
    );
  }

  checkVehicleStatus() {
    if (this.allData['entity_type'] === 'group') {
      let vehicleId = '';
      this.allData?.['bulkInfo']?.[0]?.['ProductInfo'].forEach((vehicle) => {
        vehicleId = vehicle?.['vehicle_images']?.['vehicle_id'];

        if (vehicleId) {
          const payload = {
            vehicle_id: vehicleId,
            is_sold: 1,
            is_reserved: 1,
          };

          this.auctionService.vehicleStatusCheck(payload).subscribe(
            (res) => {},
            (error: HttpErrorResponse) => {
              console.error(error);
            }
          );
        }
      });

      this.updateDocStatus(); // doc update api call
    } else {
      if (this.getVehicleId) {
        const params = {
          vehicle_id: this.getVehicleId,
          is_sold: 1,
          is_reserved: 1,
        };

        this.VehicleStatusApiCall(params);
      } else {
        this.reportService
          .paymentDocStatus(this.activroute, this.docStatus)
          .subscribe(
            (res: object) => {
              if (res['success'] === true) {
                this.paymentDocStaus = true;
                this.paymentDoc[this.paymentDocIndex]['payment_doc_status'] =
                  true;
                this.paymentDocIndex = null;
              }

              this.loading = false;
            },
            (error: HttpErrorResponse) => {
              this.loading = false;
            }
          );
      }
    }
  }

  VehicleStatusApiCall(params) {
    this.loading = true;

    this.auctionService.vehicleStatusCheck(params).subscribe(
      (res: HttpResponse<any>) => {
        if (res.body['success'] || res.status === 200) {
          this.reportService
            .paymentDocStatus(this.activroute, this.docStatus)
            .subscribe(
              (res: object) => {
                if (res['success'] === true) {
                  this.paymentDocStaus = true;
                  this.paymentDoc[this.paymentDocIndex]['payment_doc_status'] =
                    true;
                  this.paymentDocIndex = null;
                }

                this.loading = false;
              },
              (error: HttpErrorResponse) => {
                this.loading = false;
              }
            );
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.auctionAuthCheck();
        } else {
          this.toastr.error('Something went wrong!');
        }
        this.loading = false;
      }
    );
  }

  updateDocStatus() {
    this.reportService
      .paymentDocStatus(this.activroute, this.docStatus)
      .subscribe(
        (res) => {
          if (res['success'] === true) {
            this.paymentDocStaus = true;
            this.paymentDoc[this.paymentDocIndex]['payment_doc_status'] = true;
            this.paymentDocIndex = null;
          }

          this.loading = false;
          this.getPaymentDoc();
        },
        (error: HttpErrorResponse) => {
          this.loading = false;
          console.error(error);
        }
      );
  }

  getAuctionProductDetails() {
    this.loading = true;
    let getAuctionId = this.activroute;

    this.auctionService.getEditAuctionData(getAuctionId).subscribe(
      (res: any) => {
        this.approveRequire = res['data']?.['admin'];
        this.approveStatus = res['data']['approval'];
        this.queryParam = res['data']['entity_type'];

        this.currentAuction = res['data'];

        if (res['data']['entity_type'] === 'individual') {
          this.isIndividualAuction = true;
        } else if (res['data']['entity_type'] === 'individual_batch') {
          this.vehicles = this.sharedService.modifiedData(
            res['data']['ProductInfo']
          );
          this.isBatchAuction = true;
        } else if (res['data']['entity_type'] === 'group') {
          this.vehicles = this.sharedService.modifiedData(
            res['data']['bulkInfo'][0]['ProductInfo']
          );
          this.isBulkAuction = true;
        }

        if (this.vehicles.length) {
          this.initialRenderVehicleDetails(this.vehicles[0]);
        }

        localStorage.setItem('prodData', JSON.stringify(res['data']));
        let getData = JSON.parse(localStorage.getItem('prodData') as any);
        this.productData = getData;
        this.allData = getData;

        this.getVehicleId = this.allData?.vehicle_images?.vehicle_id;
        if (this.allData['entity_type'] !== 'individual') {
          if (
            this.allData['entity_type'] == 'group' &&
            this.allData['auction_type'] !== '1'
          ) {
            localStorage.setItem(
              'auction_id',
              JSON.stringify(res['data']?.ProductInfo[0]?.auction_id)
            );
            localStorage.setItem(
              'individual_auction_id',
              JSON.stringify(res['data']?.ProductInfo[0]?.auction_id)
            );
          }
        }

        let setbiddingTimeIntervalForIndiBatch = localStorage.setItem(
          'bidding_time_interval',
          JSON.stringify(this.allData['bidding_time_interval'])
        );
        let setCountdownTimerlForIndiBatch = localStorage.setItem(
          'countdown_timer',
          JSON.stringify(this.allData['countdown_timer'])
        );

        // END

        this.live_auction_start_date_time =
          this.allData.live_auction_start_date_time;
        this.highestBid = this.allData.HighestBid;
        this.min_price = this.allData.min_price;
        this.reserve_price = this.allData.reserve_price;
        this.auction_type = this.allData.auction_type;

        //Count days remaining
        let getAuctionStartTime: string =
          this.allData?.live_auction_start_date_time.split(',')[0];
        this.daysRemaining = moment(
          getAuctionStartTime,
          'DD-MM-YYYY'
        ).fromNow();

        this.slides = [];
        this.productInfo = [];
        if (this.allData['entity_type'] === 'individual') {
          this.showIndiviDualCrad = false;

          const img = this.allData?.['vehicle_images']?.['parts_images'].filter(
            (partImg) => {
              if (partImg['part_name'] === 'Front') {
                return partImg;
              }
            }
          );

          const imgURl = environment.imgBaseUrl + img?.[0]?.['image'];
          this.getImageUrl = this.allData?.['vehicle_images']?.['parts_images']
            ? imgURl
            : this.getImageUrl;
          this.getImageUrl = this.allData?.imageUrl?.imageUrl?.[0]
            ?.presigned_url
            ? this.allData?.imageUrl[0]?.presigned_url
            : this.getImageUrl;

          this.getTitle =
            this.allData?.description_data['Model Year'] +
            ' ' +
            this.allData?.description_data['Model'] +
            ' ' +
            this.allData?.description_data['Interior Colour'];
          if (this.allData['imageUrl'] !== null) {
            for (let value of Object.keys(this.allData['imageUrl'])) {
              this.slides.push(value['presigned_url']);
            }
          }
        } else if (this.allData['entity_type'] === 'group') {
          if (this.allData['auction_type'] === '1') {
            this.getImageUrl =
              this.allData?.bulkInfo[0]?.BatchImageUrl == null
                ? ''
                : this.allData?.bulkInfo[0]?.BatchImageUrl[0]?.presigned_url;
            this.getTitle = this.allData['title'];
            this.showIndiviDualCrad = false;

            // for (let value of this.allData['bulkInfo']?.[0]?.['BatchImageUrl']) {
            //   this.slides.push(value['presigned_url']);
            // }
          } else if (this.allData['auction_type'] === '0') {
            localStorage.setItem(
              'productInfoLength',
              JSON.stringify(this.allData['ProductInfo'].length)
            );
            this.getImageUrl = this.allData?.ProductInfo[0]?.imageUrl[0]
              ?.presigned_url
              ? this.allData?.ProductInfo[0]?.imageUrl[0]?.presigned_url
              : '';
            this.getTitle =
              this.allData?.ProductInfo[0].description_data['Model Year'] +
              ' ' +
              this.allData?.ProductInfo[0].description_data['Model'] +
              ' ' +
              this.allData?.ProductInfo[0].description_data['Interior Colour'];
            for (let value of this.allData['ProductInfo']) {
              this.slides.push(value['imageUrl'][0]['presigned_url']);
            }
          }
          if (this.allData['auction_type'] === '0') {
            this.productInfo = [];
            for (let i = 0; i < this.allData['ProductInfo'].length; i++) {
              this.productInfo.push({
                image:
                  this.allData['ProductInfo'][i]?.imageUrl[0]?.presigned_url,
                carName:
                  this.allData['ProductInfo'][i]?.description_data[
                    'Model Year'
                  ] +
                  ' ' +
                  this.allData['ProductInfo'][i]?.description_data['Model'] +
                  ' ' +
                  this.allData['ProductInfo'][i]?.description_data[
                    'Interior Colour'
                  ],
                auctionStartTime:
                  this.allData['live_auction_start_date_time'].split(',')[1],
                auctionStartDate:
                  this.allData['live_auction_start_date_time'].split(',')[0],
                buyNowPrice: this.allData['buy_now_price'],
                currentPreBid: this.allData['HighestBid'],
                financing: '--',
                auctionId: this.allData['ProductInfo'][i]?.auction_id,
                productid: this.allData['ProductInfo'][i]?.product_id,
                index: i,
                productDetails: this.allData['ProductInfo'][i],
              });
            }
          }
        }
        this.loading = false;
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        }
      }
    );
  }

  bidHistory() {
    this.bidHistoryData = [];

    let getAuctionId = this.activroute;

    this.auctionService.auctionLiveBiddingHistory(getAuctionId).subscribe(
      (res: any) => {
        for (let object of res['data']) {
          let date = object['created_at'].toString().split(',')[0];
          let time = object['created_at'].toString().split(',')[1];

          this.bidHistoryData.push({
            Bidding_amount: object['message'],
            Bidding_time: time,
            Bidding_date: date,
            ...object,
          });
        }
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        }
      }
    );
  }

  updateStatus(auctionId, status) {
    this.auctionService.updateStatus(auctionId, status).subscribe((res) => {
      if (res['success'] === true) {
        window.location.reload();
      }
    });
  }

  renderVehicleDetails(vehicleInfo: object) {
    this.showVehicleDetails = true;

    this.vehicleDetails = vehicleInfo['description_data'];
  }

  initialRenderVehicleDetails(vehicle: object) {
    this.renderVehicleDetails(vehicle);
  }

  getBase64(blob: Blob) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  async getDocument(event: Event, docName: string) {
    const document = (event.target as HTMLInputElement).files[0];

    if (document?.size > 5 * 1024 * 1024) {
      this.toastr.error('File size should be under 5 MB', 'limit exceeds');
      return;
    }

    const base64: any = await this.getBase64(document);

    let base64WithOutType: string;
    base64WithOutType = base64.split(',')[1];

    this.invoice?.forEach((doc, index) => {
      if (doc['name'] === docName) {
        this.invoice.splice(index, 1);
      }
    });

    this.invoice.push({ image: base64WithOutType, name: docName });

    if (this.globalDocsObj[docName]) {
      this.globalDocsObj[docName]['enableUpload'] = true;
    }

    this.uploadBtnStatus = false;
  }

  getAuctionInvoice(auctionId: string, docToDelete?: string) {
    if (docToDelete) {
      this.globalDocsObj[docToDelete]['available'] = false;
      this.globalDocsObj[docToDelete]['enableUpload'] = false;
    } else {
      this.auctionService.getAuctionInvoice(auctionId).subscribe(
        (res) => {
          if (res['success'] && res['data']['invoice_doc'] !== null) {
            res['data']['invoice_doc']?.forEach((doc) => {
              if (this.globalDocsObj[doc['document_name']]) {
                this.globalDocsObj[doc['document_name']]['available'] = true;
                this.globalDocsObj[doc['document_name']]['imageUrl'] =
                  doc['imageUrl']['presigned_url'];
                this.globalDocsObj[doc['document_name']]['id'] = doc['doc_id'];
                this.globalDocsObj[doc['document_name']]['uploadTime'] =
                  doc['created_at'];
              }
            });
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  viewInvoice(invoiceUrl: string) {
    window.open(invoiceUrl, '_blank');
  }

  openRejectWhyModal(template: TemplateRef<any>, index, docId, documentName) {
    this.modalRef = this.modalService.show(template, this.modalConfig);
    this.paymentDocIndex = index;
    this.paymentDocId = docId;
    this.rejectDocName = documentName;
  }

  onSubmitReject() {
    if (!this.whyReject) {
      return this.toastr.error('Please provide reason');
    }
    this.rejectLaddaBtn = true;
    const payload = {
      approve: 0,
      document_id: this.paymentDocId,
      notes: this.whyReject,
    };

    this.reportService
      .paymentDocStatus(this.activroute, payload)
      .subscribe((res) => {
        if (res['success']) {
          // this.paymentDocStaus = false
          if (this.rejectDocName === 'Payment') {
            this.paymentDocStaus = false;
          }
          this.paymentDoc[this.paymentDocIndex]['payment_doc_status'] = false;
          this.paymentDocIndex = null;
          this.paymentDocId = '';
          this.modalRef?.hide();
          this.whyReject = '';
          this.rejectDocName = '';
        }
        this.rejectLaddaBtn = false;
      });
  }

  uploadDocument(auctionId: string, docName: string, index: number) {
    this.laddaBtns[index] = true;
    const docToUpload = this.invoice.filter((doc) => doc['name'] === docName);

    if (!docToUpload.length) {
      this.laddaBtns[index] = false;
      return this.toastr.error('No Document found with this name: ' + docName);
    }

    const payload = {
      documents: docToUpload,
    };

    this.auctionService.uploadAuctionInvoice(auctionId, payload).subscribe(
      (res) => {
        if (res['success']) {
          this.laddaBtns[index] = false;
          this.toastr.success(res['message']);

          this.getAuctionInvoice(auctionId);
        }
      },
      (error) => {
        console.log('Here', error);

        this.laddaBtns[index] = false;
        this.toastr.error(error.error['errors']);
      }
    );
  }

  deleteAdminDoc(auctionId: string, docId: string, docName: string, index) {
    this.laddaBtns[index] = true;

    const payload = {
      auction_invoice_id: docId,
    };

    this.auctionService.deleteAuctionInvoice(auctionId, payload).subscribe(
      (res) => {
        if (res['success']) {
          this.laddaBtns[index] = false;
          this.toastr.success(res['message']);
          this.getAuctionInvoice(this.activroute, docName);
        }
      },
      (error) => {
        this.laddaLoading = false;
      }
    );
  }

  goBack() {
    this.sharedService.goBack();
  }

  dateFormatter(inputDate: string) {
    if (!inputDate) {
      return '--';
    }

    const date = new Date(inputDate);

    let formattedTime = new Intl.DateTimeFormat('en-GB', {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
      timeZone: 'Asia/Riyadh', // Saudi Arabia timezone
    }).format(date);

    formattedTime = formattedTime.replace(/([ap]m)/, (match) =>
      match.toUpperCase()
    );

    const formattedDate = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Asia/Riyadh', // Saudi Arabia timezone
    }).format(date);

    const finalFormattedDate = `${formattedTime}, ${formattedDate.replace(
      /\//g,
      '.'
    )}`;

    return finalFormattedDate;
  }
}
